import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import "./PopUp.css";
import image from "../../../components/Assets/img/misc/commingSoonedit2.png";
const ErrorRoutePage = () => {
  const history = useHistory();
  const linkroute = useCallback(() => history.push("/"), [history]);
  return (
    <>
      <div className="popUpRoot">
        <div className="popUpBox">
          <div style={{ margin: "16px auto 50px auto" }}>
            <h1></h1>
          </div>
          <img className="popUpImg" alt="" src={image} />
          <div style={{ margin: "40px 10% 50px 10%" }}>
            <h4 style={{ lineHeight: "40px" }}>
              {/* {"We are currently working on this feature and will launch soon!"} */}
              Seems like you are on the wrong planet!
              <span onClick={linkroute}> Click here </span>
              to go to the home page.
            </h4>
          </div>
        </div>
      </div>
    </>
  );
};

// CommingSoonPopUp.propTypes = {
// };

export default ErrorRoutePage;
